import { connect } from 'react-redux'
import MembershipPane from '../../../components/riders/editrider/membership/MembershipPane'
import * as actions from '../../../state/actions/riders'
import * as serviceActions from '../../../state/actions/services'
import * as membershipActions from '../../../state/actions/membership_request'
import { IMembershipObject, IRiderObject, IStoreState } from '../../../types'
import { getRiderById } from '../../../state/reducers/riders/index'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const rider = getRiderById(state.riders, ownProps.riderId)
  return {
    rider,
    orgId: state.organizations.currentOrgId,
    riderId: ownProps.riderId,
    memberships: state.membership.items,
    services: state.service.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getMembershipList: (riderId: string, orgId: string) =>
      dispatch(membershipActions.getMembershipListByRiderIdAndOrgId(riderId, orgId)),

    getServiceList: (type: string, orgId: string) => {
      dispatch(serviceActions.fetchServiceList(type, orgId))
    },
    saveMembership: (rider: IRiderObject, memberships: IMembershipObject[]) => {
      return dispatch(actions.updateRiderMemberships(rider, memberships))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipPane)



// WEBPACK FOOTER //
// ./src/containers/riders/editrider/MembershipPane.ts